import { cn } from "./cn";

/**
 * Contenedor de tabla (DESIGN.md §6 tablas): borde redondeado + scroll
 * horizontal. Reemplaza los `overflow-hidden` que, en móvil o con la letra
 * agrandada (A+/A++), cortaban columnas sin forma de verlas.
 *
 *   <TableWrap label="Socios">
 *     <table className="min-w-full text-sm">…</table>
 *   </TableWrap>
 *
 * Con `label`, el contenedor es una región enfocable con nombre: se puede
 * desplazar con el teclado (flechas) cuando la tabla es más ancha que la
 * pantalla.
 */
interface TableWrapProps extends React.HTMLAttributes<HTMLDivElement> {
  /** Nombre accesible de la región desplazable (ej. "Boletas del período"). */
  label?: string | undefined;
}

export function TableWrap({
  label,
  className,
  children,
  ...rest
}: TableWrapProps): JSX.Element {
  return (
    <div
      className={cn(
        "overflow-x-auto rounded-lg bg-white ring-1 ring-neutral-200",
        "focus:outline-none focus-visible:ring-2 focus-visible:ring-brand-500",
        className,
      )}
      {...(label ? { role: "region", "aria-label": label, tabIndex: 0 } : {})}
      {...rest}
    >
      {children}
    </div>
  );
}
